<template>
  <el-dialog
    v-dialogDrag
    :title="title"
    :visible.sync="dialogVisible"
    width="65%"
    :close-on-click-modal="false"
    top="5vh"
    class="self-dialog-form"
    @close="dialogClosed"
  >
    <el-form
      ref="addFromRef"
      :model="formData"
      class="dict_dialog_form"
      :rules="formRules"
      label-position="top"
    >
      <el-row>
        <el-col :span="7" class="padding-right20">
          <el-form-item
            :label="$t('dictInfo.dictName')"
            prop="dictName"
            label-width="120px"
            class="padding-right25"
          >
            <el-input
              v-model="formData.dictName"
              :placeholder="$t('dictInfo.pleaseEnterDictName')"
              maxlength="64"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="padding-right20">
          <el-form-item
            :label="$t('dictInfo.dictCode')"
            prop="dictCode"
            label-width="120px"
            class="padding-right25"
          >
            <el-input
              v-model="formData.dictCode"
              :placeholder="$t('dictInfo.pleaseEnterDictCodee')"
              :disabled="operType == 'edit'"
              maxlength="64"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('dictInfo.type')"
            prop="dictPermission"
            label-width="100px"
            class="padding-right25"
          >
            <el-select
              v-model="formData.dictPermission"
              :placeholder="$t('dictInfo.pleaseChooseType')"
              style="width: 100%"
              :disabled="operType === 'edit'"
              @change="dictPermissionChange"
            >
              <el-option
                v-for="item in isSystem?isSystemEnum:noSystemEnum"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$t('dictInfo.dictStatus')"
            prop="dictStatus"
            label-width="100px"
          >
            <el-select
              v-model="formData.dictStatus"
              :placeholder="$t('dictInfo.pleaseChooseDictStatus')"
              style="width: 100%"
              :disabled="!isSystem && formData.initDictPermission === 'SYSTEM_BUSINESS'"
            >
              <el-option
                v-for="item in dictStatusEnum"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item
          :label="$t('dictInfo.description')"
          prop="description"
          label-width="100px"
        >
          <el-input
            v-model="formData.description"
            type="textarea"
            :placeholder="`${$t('common.pleaseEnter')}内容(${$t('common.wordCountLimit', [$getInputMaxLimitConst('limit200')])})`"
            :maxlength="$getInputMaxLimitConst('limit200')"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-row>
      <div
        :style="{ width: '100%', height: '8px', background: '#F9F9FB', margin: '12px 0 24px 0' }"
      ></div>
      <div class="casecade--list">
        <div class="casecade--description">{{ $t("dictInfo.dictList") }}</div>
        <div class="casecade--button">
          <el-button
            icon="el-icon-zoom-in"
            type="success"
            @click="addDetailDict()"
          >
            {{ $t("dictInfo.addDict") }}
          </el-button>
        </div>
      </div>
      <div class="section--table">
        <div class="section--table--tbody">
          <el-table
            v-loading="loading"
            :data="formData.dictItems"
            class="self-table"
            style="width: 100%"
            max-height="392"
          >
            <el-table-column type="index" :label="$t('common.order')" width="80" />
            <el-table-column
              prop="dictLabel"
              :label="$t('dictInfo.dictItemInfo.dictLabel')"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`dictItems.${scope.$index}.dictLabel`"
                  :rules="formRules.dictLabel"
                  style="margin-bottom: 0"
                >
                  <el-input
                    v-model="scope.row.dictLabel"
                    :placeholder="$t('dictInfo.dictItemInfo.pleaseEnterDictName')"
                    maxlength="64"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="dictValue"
              :label="$t('dictInfo.dictItemInfo.dictValue')"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="`dictItems.${scope.$index}.dictValue`"
                  :rules="formRules.dictValue"
                  style="margin-bottom: 0"
                >
                  <el-input
                    v-model="scope.row.dictValue"
                    :placeholder="$t('dictInfo.dictItemInfo.pleaseEnterDictCode')"
                    :disabled="scope.row.id ? true : false"
                    maxlength="64"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="sort"
              :label="$t('dictInfo.dictItemInfo.sort')"
              width="120"
            >
              <template slot-scope="scope">
                <el-form-item style="margin-bottom: 0">
                  <el-input-number
                    v-model="scope.row.sort"
                    :precision="0"
                    controls-position="right"
                    :min="0"
                    :max="2147483647"
                    :placeholder="$t('dictInfo.dictItemInfo.pleaseEnterSort')"
                  ></el-input-number>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="systemDefault"
              :label="$t('dictInfo.dictItemInfo.systemDefault')"
              width="100"
            >
              <template slot-scope="scope">
                <el-form-item style="margin-bottom: 0">
                  <el-select
                    v-model="scope.row.systemDefault"
                    :placeholder="$t('dictInfo.dictItemInfo.pleaseEnterType')"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in isSystemCaseEnum"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="description"
              :label="$t('dictInfo.dictItemInfo.description')"
            >
              <template slot-scope="scope">
                <el-form-item style="margin-bottom: 0">
                  <el-input
                    v-model="scope.row.description"
                    :placeholder="$t('dictInfo.dictItemInfo.PleaseEnterDescription')"
                    maxlength="200"
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('common.action')"
              width="100"
            >
              <template slot-scope="scope">
                <el-form-item style="margin-bottom: 0">
                  <el-button
                    type="text"
                    style="color: #e60000"
                    @click="casecadeDelete(scope.$index, scope.row.id)"
                    v-if="!(!isSystem && scope.row.systemDefault)"
                  >
                    {{ $t("common.delete") }}
                  </el-button>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer" style="padding-right: 5px">
      <el-button plain @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleConfirm"
      >
        {{ $t("public.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import Dict from "@/api/dict/dict";
import Role from "@/api/role/role";
import { mapGetters } from "vuex";
export default {
  name: "AddEditDialog",

  props: {
    isSystemAdmin: {
      type: Boolean,
      default: false
    },
    operType: {
      type: String,
      default: "add"
    },
    dialogData: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      // 添加表单的数据对象
      formData: {
        dictItems: []
      },
      isSystemEnum: [
        {
          id: "SYSTEM",
          label: "系统(不可编辑)"
        },
        {
          id: "SYSTEM_BUSINESS",
          label: "系统(可增子项)"
        }
      ],
      noSystemEnum: [
        {
          id: "SYSTEM_BUSINESS",
          label: "系统(可增子项)"
        },
        {
          id: "BUSINESS",
          label: " 业务"
        }
      ],
      dictStatusEnum: [
        {
          id: "ENABLED",
          label: "启用"
        },
        {
          id: "NOT_ENABLED",
          label: "停用"
        }
      ],
      isSystemCaseEnum: [
        {
          id: true,
          label: "是"
        },
        {
          id: false,
          label: "否"
        }
      ],
      // 添加表单的验证规则
      formRules: {
        dictName: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t("dictInfo.dictName")}`,
            trigger: "blur"
          }
        ],
        dictCode: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t("dictInfo.dictCode")}`,
            trigger: "blur"
          }
        ],
        dictPermission: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t("dictInfo.type")}`,
            trigger: "blur"
          }
        ],
        dictStatus: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t("dictInfo.dictStatus")}`,
            trigger: "blur"
          }
        ],
        dictLabel: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t(
              "dictInfo.dictItemInfo.dictLabel"
            )}`,
            trigger: "blur"
          }
        ],
        dictValue: [
          {
            required: true,
            message: `${this.$t("common.pleaseEnter")}${this.$t(
              "dictInfo.dictItemInfo.dictValue"
            )}`,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["isSystem"])
  },
  watch: {
    dialogData() {
      if (this.dialogData) {
        this.formData = JSON.parse(JSON.stringify(this.dialogData));
        this.$set(this.formData, "initDictPermission", this.formData.dictPermission);
        if (this.formData.dictItems){
          this.formData.dictItems.forEach(item => {
            item.systemDefaultInit = item.systemDefault;
          });
        }
        this.dialogVisible = true;
      }
    }
  },
  created() {
  },

  methods: {
    // 确认提交按钮事件
    handleConfirm() {
      this.$refs.addFromRef.validate(valid => {
        if (valid) {
          if (this.operType === "add") {
            this.addDict(this.formData);
          } else {
            this.editDict(this.formData);
          }
        }
      });
    },
    // 新增确认提交
    addDict(data) {
      this.loading = true;
      Dict.addDict(data)
        .then(res => {
          this.successCallback(res.data, true);
        })
        .catch(() => {
          this.loading = false;
          // this.$message.warning()
        });
    },
    // 编辑确认提交
    editDict(data) {
      this.loading = true;
      Dict.editDict(data)
        .then(res => {
          this.successCallback(res, false);
        })
        .catch(() => {
          this.loading = false;
          // this.$message.warning()
        });
    },

    /**
     * @name: 接口成功调用
     * @test: test front
     * @msg:
     * @param {*} res 新增编辑接口返回值
     * @param {*} isAdd  true代表是新增成功 false 代表是编辑成功
     * @return {*}
     */
    successCallback(res, isAdd) {
      this.loading = false;
      if (res) {
        this.$message.success(this.$t(`${isAdd ? "common.addSuccess" : "common.editSuccess"}`));
        this.dialogVisible = false;
        this.$emit("success", true);
      }
    },
    // 关闭弹框
    dialogClosed() {
      this.addFrom = {};
      this.$nextTick(() => {
        this.$refs.addFromRef.clearValidate();
      });
    },

    // 级联子项删除 ---页面删除
    casecadeDelete(index) {
      // 从列表删除数据
      this.formData.dictItems.splice(index, 1);
    },
    // 子项列表新增
    addDetailDict() {
      const obj = { systemDefault: this.isSystem};
      this.$nextTick(() => {
        this.formData.dictItems.push(obj);
      });
    },
    dictPermissionChange(val){
      if (val === "SYSTEM"){
        this.formData.dictItems.forEach(item => {
          item.systemDefault = true;
        });
      } else if (!this.isSystem && val === "SYSTEM_BUSINESS"){
        item.systemDefault = true;
      }
    }
  }
};
</script>

<style>
.el-dialog__body {
  max-height: 100% !important;
  overflow-y: hidden !important;
}
</style>

<style lang="scss" scoped >
.custom--section {
  padding: 10px 20px;
}
.section--action,
.casecade--list {
  display: flex;
  align-items: center;
  margin-top: 15px;
  .section--search,
  .casecade--description {
    flex: 1;
    .el-input {
      width: 350px;
    }
    .curpor-pointer {
      cursor: pointer;
    }
  }
  .section--btn,
  .casecade--button {
    flex: 1;
    text-align: right;
  }
}
.casecade--description {
  font-size: 18px;
}
.section--table {
  margin-top: 10px;
}
.section--table--page {
  margin-top: 10px;
  text-align: right;
}
.view--casecade-title {
  font-weight: 500;
  font-size: 18px;
  margin: 25px 5px 10px;
}
.padding-right25 {
  padding-right: 25px;
}
</style>

<style lang="scss" scoped>
.dict_dialog_form {
  .el-input.is-disabled .el-input__inner {
    background-color: #f9f9fb;
  }
}
::v-deep .el-table {
  td,
  th {
    padding: 0;

    & > .cell {
      display: flex;
      align-items: center;
      // line-height: 70px;
      height: 64px;
      overflow: hidden;
    }
  }

  td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #ebecef !important;
  }
}
</style>
